import {combineReducers} from 'redux';
import alert from './alerts'
import users from './users'
import transactions from './transactions'
import vouchers from './vouchers'



export default combineReducers({alert, users, transactions, vouchers})